import type { PartialNever } from '@weft/utils';
import { VyTable } from 'apps/app/src/components/new-design/table/vy-table/VyTable';
import { withGlobalSearchParams } from 'apps/app/src/components/utility/GlobalSearchParamsBoundary';
import { useAllReports } from 'apps/app/src/hooks/requests/use-all-reports';
import type { ReportJobsDownloadProps } from '../report-jobs-section/ReportJobsSection';
import { getAllReportsColumns } from './all-reports-consts/all-reports-columns';

type AllReportsProps = (Required<ReportJobsDownloadProps> | PartialNever<ReportJobsDownloadProps>);

const AllReports: React.FC<AllReportsProps> = ({ onDownload }) => {
  const data = useAllReports();
  const columns = getAllReportsColumns(onDownload);

  return (
    <VyTable
      columns={columns}
      getRowId={() => crypto.randomUUID()}
      items={data}
      itemsCount={data.length}
      loadingItems={false}
      showPagination={false}
      getRowClassName={() => 'group'}
      sx={{
        paddingBottom: '72px',
      }}
    />
  );
};

const AllReportsWithSearchParamBoundary = withGlobalSearchParams(AllReports);
export { AllReportsWithSearchParamBoundary as AllReports };
